import { useParams } from 'react-router-dom';
import type { TaskRo } from 'src/app/services/api.generated';
import { useAppSelector } from 'src/app/reduxCustomHooks';
import type { RootStateType } from 'src/app/store';

/** Document id from the /edit/:id route: the one the user is looking at. */
export const useRoutedTaskId = (): string | undefined =>
  useParams<{ id: string }>().id || undefined;

/** The edit-page task, but only if it is the routed document. */
export const selectRoutedEditTask = (
  state: RootStateType,
  routeTaskId: string | undefined
): TaskRo | null => {
  const task = state.editPage.task;
  return task && routeTaskId && task.id === routeTaskId ? task : null;
};

/**
 * Read the edit-page task through the route. During the render right after a
 * navigation the slice can still hold the previous document; this returns
 * null then, so no title, id or action can come from that document.
 */
export const useEditPageTask = <T>(
  select: (task: TaskRo | null) => T,
  equalityFn?: (left: T, right: T) => boolean
): T => {
  const routeTaskId = useRoutedTaskId();
  return useAppSelector(
    (state) => select(selectRoutedEditTask(state, routeTaskId)),
    equalityFn
  );
};
